import { useEffect, useState } from "react";
import Footer from "../components/common/footer";
import InputFiled from "../components/common/inputFiled";
import ButtonSubmit from "../components/common/buttonSubmit";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HttpService } from "../services/HttpService";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/images/logoFederfarma.png";
import {
  updateUser,
  updateSaml,
  initLoginData,
} from "../redux/reducer/LoginReducer";
import { CheckNavigation, isLoggedUser } from "../services/Auth";
import { useAppDispatch } from "../redux";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [spinner, setSpinner] = useState(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useSelector((store: any) => store.login);

  /**
   * Retrieve SAML login token from query string.
   * @returns {string} token
   */
  const getToken = () => {
    return searchParams.get("token");
  };

  /**
   * Update some state and redirect to the right page.
   * @param checkNavigationResponse /checknavigation response with entity IDs and navigation detail
   */
  const updateStateAndNavigate = (checkNavigationResponse: any) => {
    dispatch(initLoginData(checkNavigationResponse));
    navigate(checkNavigationResponse.navigation);
  };

  /**
   * Sends login detail to the server and manage the response.
   */
  const doLogin = async () => {
    setSpinner(true);

    try {
      let result: any = await HttpService.post(
        `${process.env.REACT_APP_API}/user/login`,
        {
          username: username,
          password: password,
          token: getToken(),
        }
      );

      dispatch(updateUser(result.data.user));
      dispatch(updateSaml(result.data.user.saml));
    } catch (error) {
      console.log(error);
      setSpinner(false);
      setError(t("login.error"));
    }
  };

  /**
   * Initial checks:
   * - if already logged in go to the right page
   * - if token is present do a token login
   * Token is sent along username and password, if empty the server simply ignores it.
   * Token login is part of our custom SAML login sequence,
   * proposed by Matteo to be as CORS compatible as possible:
   * 1. SAML login React page
   * 2. IdP login on third party portal
   * 3. callback on our server, generate token and redirect here
   * 4. token login
   */
  useEffect(() => {
    const token = getToken();
    if (token) {
      doLogin();
    }
  }, []);

  useEffect(() => {
    if (isLoggedUser(user)) {
      if (user.forcePasswordChange) {
        navigate("/change-password");
      } else {
        CheckNavigation().then(updateStateAndNavigate);
      }
    }
  }, [user]);

  return (
    <>
      <div className="container">
        <div className="TableCenter h-100 ">
          <div className="Center">
            <div className="col-md-6 col-lg-3 pl-0 pr-0 mx-auto pt-4">
              <div className="text-center">
                <img src={logo} className="mb-4 " alt="Logo" />
              </div>
              <div className="form-outline mb-4">
                <label className="p-1 ms-2">
                  {t("login.username-placeholder")}
                </label>
                <InputFiled
                  value={username}
                  name="username"
                  handleChange={setUsername}
                  className="input-bg-white"
                />
              </div>
              <div className="form-outline mb-4">
                <label className="p-1 ms-2">
                  {t("login.password-placeholder")}
                </label>
                <InputFiled
                  type="password"
                  value={password}
                  name="password"
                  handleChange={setPassword}
                  className="input-bg-white"
                />
              </div>
              <div className="text-center">
                <ButtonSubmit
                  spinner={spinner}
                  textButton={t("login.submit")}
                  handleChange={doLogin}
                  className="w-100"
                />
              </div>
              {error && (
                <div className="text-danger text-center mt-3">{error}</div>
              )}
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
